var Skills = [
    { key: 1, name: <div><i className="fab fa-html5"></i> HTML</div>, width: '80%' },
    { key: 2, name: <div><i className="fab fa-css3"></i> CSS</div>, width: '60%' },
    { key: 3, name: <div><i className="fab fa-react"></i> React</div>, width: '30%' },
    { key: 4, name: <div><i className="fab fa-python"></i> Python</div>, width: '60%' },
    { key: 5, name: <div><i className="fab fa-js-square"></i> JavaScript</div>, width: '60%' },
    { key: 6, name: <div><i className="fab fa-node-js"></i> NodeJs</div>, width: '80%' },
    { key: 7, name: <div><i className="fas fa-database"></i> MYSQL</div>, width: '50%' },
    { key: 8, name: <div><i className="fas fa-database"></i> MongoDb</div>, width: '50%' },
    { key: 9, name: <div>tailwind CSS</div>, width: '50%' },
    { key: 10, name: <div><i className="fas fa-mug-hot"></i> JAVA</div>, width: '60%' },
    { key: 11, name: <div>C++</div>, width: '60%' },


]

export default Skills;